import React, { useEffect, useState } from "react";
import CustomInput from "../../../Components/InputCompo/CustomInput";
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import CustomSelection from "../../../Components/SelectionComp/CustomSelection";
import ButtonComp from "../../../Components/ButtonComp/ButtonComp";
import { InputCompo } from "../../../Components/InputCompo/InputCompo";
import CustomFileInput from "../../../Components/InputCompo/CustomFileInput";
import HeaderCompo from "../../../Components/HeaderComp/HeaderCompo";
import * as Yup from "yup";

import { useMutation, useQuery } from "@tanstack/react-query";
import {
    discoveryLegalMainSubmit,
    discoveryLegalQ,
    editRegistration,
} from "../../../Store/auth/register";
import { Form, Formik, useFormik } from "formik";
import { enqueueSnackbar } from "notistack";
import { allCountries } from "../RegistrationDatas";
import Loading from "../../../Components/Loader/Loading";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ModalComp from "../../../Components/ModalComp";
import CloseIcon from "@mui/icons-material/Close";
import MultipleSelect from "../../../Components/SelectionComp/MultipleSelect";
const LegalRegistration = ({ setSubTabs }) => {
    // handling success and errors
    const application_no = localStorage.getItem("RegKey");
    const DBName = localStorage.getItem("Db_name");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const gsn_no = localStorage.getItem("gsn_no");
    const { isLoading: fieldLoading, data: question } = useQuery({
        queryKey: "LegalQuestions",
        queryFn: () =>
            discoveryLegalQ(
                application_no && DBName ? DBName : "Pending DB",
                application_no
            ),
        cacheTime: 1000 * 60 * 5,
        staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
    });
    if (!application_no) {
        setSubTabs({ "Get Started": true });
    }
    // validation for fields
    const modelSchema = Yup.object().shape({
        ...question?.documents?.reduce((schema, fields) => {
            if (fields.type.toLowerCase() !== "section") {
                // Define validation rules
                let fieldValidation = Yup.string();

                // Apply different validation rules based on the field's validation type
                if (
                    fields.validation.toLowerCase() === "email" &&
                    !fields?.depend_question
                ) {
                    fieldValidation = fieldValidation.matches(
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        "Invalid email address"
                    );
                } else if (fields.validation.toLowerCase() === "pan") {
                    fieldValidation = fieldValidation.matches(
                        /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                        "Invalid PAN Number. It should be in the format: ABCDE1234F."
                    );
                } else if (fields.validation.toLowerCase() === "pincode") {
                    fieldValidation = Yup.string().matches(
                        /^\d{6}$/,
                        "PIN code must be exactly 6 digits"
                    );
                } else if (fields.validation.toLowerCase() === "areacode") {
                    fieldValidation = fieldValidation.matches(
                        /^(123|456|789)$/,
                        "Incorrect area code"
                    );
                } else if (fields.type.toLowerCase() === "multiselect dropdown") {
                    fieldValidation = Yup.array();
                } else if (fields.validation.toLowerCase() === "website") {
                    fieldValidation = fieldValidation.url("Please enter a valid URL");
                } else if (fields.validation.toLowerCase() === "mobile") {
                    fieldValidation = fieldValidation.matches(
                        /^(?:[0-9]{10}|[0-9]{7})$/,
                        "Invalid contact number"
                    );
                } else if (fields.type.toLowerCase() === "attach") {
                    fieldValidation = Yup.object();
                } else if (fields.validation.toLowerCase() === "darpan") {
                    fieldValidation = fieldValidation.test(
                        "is-valid-darpan",
                        " Darpan Id should be in the format: XX/1234/1234567",
                        (value) => {
                            if (value?.toUpperCase() === "NA") {
                                return true;
                            }
                            return /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value);
                        }
                    );
                } else if (
                    fields.validation.toLowerCase() === "password" &&
                    !fields?.depend_question
                ) {
                    fieldValidation = fieldValidation.min(
                        8,
                        "Password must be at least 8 characters long"
                    );
                }

                // Apply required validation if the field is mandatory
                if (fields.mandatory === 1) {
                    fieldValidation = fieldValidation.required(
                        `${fields.question} is required`
                    );
                }

                // Assign the validation rule to the field in the schema
                schema[fields?.question_no] = fieldValidation;
            }

            return schema;
        }, {}),
    });

    const editModalSchema = Yup.object().shape({
        [isModalOpen?.data?.question_no]: (() => {
            let validation = Yup.string();

            // Check if isModalOpen?.data is defined
            if (!isModalOpen?.data) return validation;

            const fieldType = isModalOpen.data.type?.toLowerCase();
            const fieldValidation = isModalOpen.data.validation?.toLowerCase();

            // Apply validation based on `validation` property
            if (fieldValidation === "email" && !isModalOpen.data?.depend_question) {
                validation = validation.matches(
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    "Invalid email address"
                );
            } else if (fieldValidation === "pan") {
                validation = validation.matches(
                    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                    "Invalid PAN Number. Format: ABCDE1234F."
                );
            } else if (fieldValidation === "pincode") {
                validation = validation.matches(
                    /^\d{4}$|^\d{6}$/,
                    "PIN code must be exactly 4 or 6 digits"
                );
            } else if (fieldValidation === "mobile") {
                validation = validation.matches(
                    /^(?:[0-9]{10}|[0-9]{7})$/,
                    "Invalid contact number"
                );
            } else if (fieldValidation === "website") {
                validation = validation.url("Please enter a valid URL");
            } else if (fieldValidation === "darpan") {
                validation = validation.test(
                    "is-valid-darpan",
                    "Darpan ID should be in the format: XX/1234/1234567",
                    (value) =>
                        value?.toUpperCase() === "NA" ||
                        /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
                );
            } else if (
                fieldValidation === "password" &&
                !isModalOpen.data?.depend_question
            ) {
                validation = validation.min(
                    8,
                    "Password must be at least 8 characters long"
                );
            } else if (fieldType === "multiselect dropdown") {
                validation = Yup.array().of(Yup.string());
            } else if (fieldType === "attach") {
                validation = Yup.object();
            }

            // Apply 'required' validation if `mandatory` is 1
            if (isModalOpen.data.mandatory === 1) {
                validation = validation.required(
                    `${isModalOpen.data.question} is required`
                );
            }

            return validation;
        })()
    });


    const formik = useFormik({
        initialValues: question?.documents?.reduce((values, fields) => {
            // Check if there's an answer for the current question_no

            const answer = question?.docs_answers.length > 0 ? question?.docs_answers?.find(ans => ans.question_no === fields.question_no) : '';

            if (answer?.answer && fields.type.toLowerCase() !== "section" && question?.docs_answers.length > 0 || answer?.upload_document && question?.docs_answers.length > 0 && fields.type.toLowerCase() !== "section") {
                if (fields.type.toLowerCase() === "checkbox") {
                    values[fields?.question_no] = answer?.answer === '1' ? true : false;  // Initialize with the answer if available
                } else {
                    values[fields?.question_no] = answer?.answer || { fileName: answer?.upload_document };  // Initialize with the answer if available
                }
            } else {
                if (fields?.question_no === 'DRQ-00029') {
                    values[fields?.question_no] = 'Registered Office';  // Default to an empty string if no answer exists
                }
                else {
                    values[fields?.question_no] = '';  // Default to an empty string if no answer exists

                }

            }

            return values;
        }, {}),
        validationSchema: modelSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const tempData = question?.documents?.map((fields) => {
                    if (
                        fields?.type.toLowerCase() === "attach" &&
                        values?.[fields.question_no]
                    ) {
                        return {
                            question_no: fields?.question_no,
                            attach_file: values?.[fields?.question_no]?.file64,
                            file_name: values?.[fields?.question_no]?.fileName,
                        };
                    } else if (fields?.type.toLowerCase() === "number") {
                        return {
                            question_no: fields?.question_no,
                            answer: `${values[fields?.question_no]}`,
                        };
                    } else if (fields?.type.toLowerCase() === "checkbox") {
                        return {
                            question_no: fields?.question_no,
                            answer: `${values[fields?.question_no] ? "Y" : "N"}`,
                        };
                    } else {
                        return {
                            question_no: fields?.question_no,
                            answer: values[fields?.question_no],
                        };
                    }
                });

                const structuredData = {
                    args: {
                        name: application_no,
                        discover_registration_section_2: tempData,
                    },
                };

                await submitMainForm(structuredData);
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        },
    });



    useEffect(() => {
        if (formik?.values?.['DRQ-00028']) {
            formik.setFieldValue('DRQ-00029', formik?.values?.['DRQ-00018'])
            formik.setFieldValue('DRQ-00030', formik?.values?.['DRQ-00019'])
            formik.setFieldValue('DRQ-00031', formik?.values?.['DRQ-00020'])
            formik.setFieldValue('DRQ-00032', formik?.values?.['DRQ-00021'])
            formik.setFieldValue('DRQ-00033', formik?.values?.['DRQ-00022'])
            formik.setFieldValue('DRQ-00034', formik?.values?.['DRQ-00023'])
            formik.setFieldValue('DRQ-00035', formik?.values?.['DRQ-00024'])
            formik.setFieldValue('DRQ-00036', formik?.values?.['DRQ-00025'])
            // formik.setFieldValue('DRQ-00018', 'Correspondence Address')
        } else if (formik?.values) {
            formik.setFieldValue('DRQ-00029', 'Registered Office')
            formik.setFieldValue('DRQ-00030', '')
            formik.setFieldValue('DRQ-00031', '')
            formik.setFieldValue('DRQ-00032', '')
            formik.setFieldValue('DRQ-00033', '')
            formik.setFieldValue('DRQ-00034', '')
            formik.setFieldValue('DRQ-00035', '')
            formik.setFieldValue('DRQ-00036', '')
            // formik.setFieldValue('DRQ-00018', 'Correspondence Address')


        }
    }, [formik?.values])

    

    const fileHandler = (e) => {
        const file = e?.target?.files[0];
        const name = e?.target?.name;
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                formik.setFieldValue(name, {
                    file64: base64String,
                    fileName: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    // error handling mutation

    const handleCreateSuccess = () => {
        setTimeout(() => {
            setSubTabs({ "Head of Organisation's Details": true });
        }, 1000);
        enqueueSnackbar("success!", { variant: "success" });
    };

    const handleCreateError = (error) => {
        if (error?.response?.data.status_code >= 500) {
            enqueueSnackbar(error?.response?.data?.status_message, {
                variant: "error",
            });
        } else {
            enqueueSnackbar(error?.response?.data?.message || error?.message, {
                variant: "error",
            });
        }
    };

    const createFarmerMutationOptions = {
        onSuccess: handleCreateSuccess,
        onError: handleCreateError,
    };

    // checking table fields manually

    // handle the conditions in backend data

    const evaluateCondition = (value1, condition, value2) => {
        switch (condition) {
            case "==":
                return value1 == value2; // Using loose equality as per original suggestion
            case "===":
                return value1 === value2;
            case "!==":
                if (value1 !== value2) {
                    return false;
                }
            case ">":
                return value1 > value2;
            case "<":
                return value1 < value2;
            case ">=":
                return value1 >= value2;
            case "<=":
                return value1 <= value2;
            default:
                return false;
        }
    };

    // submit form

    const { mutate: submitMainForm, isPending: mainRegistration } = useMutation({
        mutationFn: discoveryLegalMainSubmit,
        ...createFarmerMutationOptions,
    });

    // waiting for fields

    const attachFile = (e, setFieldValue) => {
        if (!e.target.files || e.target.files.length === 0) {
            setFieldValue(e.target.name, "");
            return; // Prevent further execution if no file is selected
        }
        const file = e.target.files[0];
        const name = e.target.name;
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                setFieldValue(name, {
                    attach_file: base64String,
                    file_name: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    // waiting for fields

    const commonEditOpenModal = (
        name,
        data,
        values,
        type,
        template,
        sub_question_num,
        subQuestion
    ) => {
        setIsModalOpen({
            [name]: true,
            data,
            values,
            type: type,
            template: template,
            sub_question_num: sub_question_num,
            subQuestion,
        });
    };

    const commonEditCloseModal = () => {
        if (!editLoading) {
            setIsModalOpen("");
        }
    };

    console.log(
        "docs>>>",
        question?.documents?.find((doc) => doc?.type?.toLowerCase() === "section")
            ?.template
    );

    const hasAnswerForQuestion = (subQ) => {
        let answer = ''
        const doc = question?.docs_answers?.length > 0 && question?.docs_answers?.find(doc => doc?.type.toLowerCase() === 'section');
        // Find the answer element that contains the question with the matching question number
        doc?.answer?.map(ele => {
            answer = ele.find(dt => dt?.question_no === subQ?.question_no)?.answer || ele.find(dt => dt?.question_no === subQ?.question_no)?.upload_document
        }
        );
        return answer;
    };

    const updateValues = async (values) => {
        try {
            const currentDate = await new Date();
            const structuredData = await {
                args: {
                    gsn_number: gsn_no,
                    date_and_time: formatDateTime(currentDate),
                    gsi_id: application_no,
                    question_id: isModalOpen?.data?.question_no,
                    question_text: isModalOpen?.data?.question,
                    previous_answer: question?.docs_answers?.find(
                        (doc) => doc?.question_no === isModalOpen?.data?.question_no
                    )?.answer,
                    edited_answer: values?.[isModalOpen?.data?.question_no],
                    section_name: 'Discover Registration Details'
                },
            };
            console.log("structuredData>>>>", structuredData);

            await editData(structuredData);
        } catch (error) { }
    };
    const formatDateTime = (isoString) => {
        const date = new Date(isoString);

        // Extract YYYY-MM-DD
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
        const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits

        // Extract HH:MM:SS in 24-hour format
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const { mutate: editData, isPending: editLoading } = useMutation({
        mutationFn: editRegistration,
        ...createFarmerMutationOptions,
        onMutate: async () => {
            // Cancel the current query before mutating
            // await queryClient.cancelQueries(['Questions', application_no]);
        },
        onSuccess: () => {
            // Invalidate the query to refetch the latest data
            // queryClient.invalidateQueries(['Questions', application_no]);
        },
    });
    const modalMultiSelectedValues = (values, setModalFieldValue) => {
        const fieldPath = `normalFields.${isModalOpen?.data?.question_no}`;
        setModalFieldValue(fieldPath, values?.[isModalOpen?.data?.question_no]);
        commonEditCloseModal();
    };

    useEffect(() => {
        if (!editLoading) {
            setIsModalOpen("");
        }
    }, [editLoading]);

    if (mainRegistration || fieldLoading) return <Loading />;

    return (
        <>
            <form className='flex flex-col gap-[30px]' onSubmit={formik.handleSubmit} action="">
                <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                    {question?.documents.map(Fields =>
                        <>
                            {Fields?.paremeter &&
                                <div className='w-[100%]'>
                                    <HeaderCompo className='text-2xl text-black' text={Fields?.paremeter} tagType='h3' />
                                </div>
                            }
                            {
                                Fields.question.toLowerCase() !== 'location on map' && Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'date' || Fields.type.toLowerCase() === 'password' ?
                                    <div className={`${Fields.condition ? !evaluateCondition(formik?.values?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && 'hidden' : ''} ${Fields?.description?.length > 250 ? 'w-[100%]' : ' w-[48%]'} flex gap-[10px] `}>
                                        <div className='w-[100%]'>
                                            <CustomInput required={Fields?.mandatory > 0 ? true : false}
                                                disabled={question?.docs_answers?.length > 0}
                                                {...formik.getFieldProps(Fields.question_no)}
                                                type={Fields.type.toLowerCase()}
                                                name={Fields.question_no} label={Fields.question}
                                            />
                                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                                        </div>
                                        {question?.docs_answers?.length > 0 && question?.docs_answers?.some(doc => doc?.answer) &&
                                            <div className="flex gap-[10px] mt-[8px]">
                                                <div onClick={() => commonEditOpenModal('edit', Fields, formik?.values)} className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]">
                                                    <BorderColorIcon className="text-white" />
                                                </div>
                                                <div onClick={() => commonEditOpenModal('comment', Fields, formik?.values)} className="bg-[#004878] h-fit rounded-full p-[8px]">
                                                    <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                </div>
                                            </div>
                                        }
                                    </div >

                                    :
                                    Fields.type.toLowerCase() === 'dropdown'
                                        ?
                                        <div className={`${Fields?.condition ? !evaluateCondition(formik?.values?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && 'hidden' : ''} ${Fields?.description?.length > 250 ? 'w-[100%]' : ' w-[48%]'} flex gap-[10px]`}>

                                            <div className='w-[100%]'>

                                                <>
                                                    <CustomSelection required={Fields?.mandatory > 0 ? true : false}
                                                        disabled={question?.docs_answers?.length > 0}
                                                        options={Fields.question === 'Country Code' ? allCountries : Fields?.question_no === "DRQ-00034" ?
                                                            Fields?.options?.filter(ele => formik.values?.['DRQ-00033']?.includes(ele.value)) :
                                                            Fields?.question_no === 'DRQ-00023' ?
                                                                Fields?.options?.filter(ele => formik.values?.['DRQ-00022']?.includes(ele.value)) :
                                                                Fields?.options}
                                                        {...formik.getFieldProps(Fields.question_no)}
                                                        name={Fields.question_no} label={Fields.question}
                                                        noSort={true}
                                                    />
                                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                                            </div>
                                            {question?.docs_answers?.length > 0 && question?.docs_answers?.some(doc => doc?.answer) &&
                                                <div className="flex gap-[10px] mt-[8px]">
                                                    <div onClick={() => commonEditOpenModal('edit', Fields, formik?.values)} className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]">
                                                        <BorderColorIcon className="text-white" />
                                                    </div>
                                                    <div onClick={() => commonEditOpenModal('comment', Fields, formik?.values)} className="bg-[#004878] h-fit rounded-full p-[8px]">
                                                        <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        :
                                        Fields.type.toLowerCase() === 'checkbox' ?
                                            <div className=' w-[100%]'>
                                                <label className="flex mt-[16px] items-center space-x-2">
                                                    <InputCompo
                                                        disabled={question?.docs_answers?.length > 0}

                                                        required={Fields?.mandatory > 0 ? true : false}
                                                        options={Fields?.options}
                                                        checked={formik.values?.[Fields?.question_no]}
                                                        {...formik.getFieldProps(Fields.question_no)}
                                                        name={Fields.question_no}
                                                        className='bg-[#004878]  text-white w-[20px] h-[20px]' type='checkbox' />
                                                    <span className='text-black'>{Fields.question}</span>
                                                </label>
                                            </div>
                                            :
                                            Fields.question.toLowerCase() === 'location on map' ?
                                                <div className='w-[100%] flex gap-[24pt]'>
                                                    <div className='w-[100%]'>

                                                        <CustomInput required={Fields?.mandatory > 0 ? true : false}
                                                            disabled={question?.docs_answers?.length > 0}

                                                            options={Fields?.options}
                                                            type={Fields.question.toLowerCase()}
                                                            {...formik.getFieldProps(Fields.question_no)}
                                                            name={Fields.question_no} label='Location on Map'
                                                        />
                                                        <ParagraphComp className='mt-[8px] text-black text-sm px-[8px]' text={'Click the Locate icon to open map and pin location'} />
                                                    </div>
                                                </div>
                                                :

                                                Fields.type.toLowerCase() === 'attach' ?
                                                    <div className={`${Fields?.condition ? !evaluateCondition(formik?.values?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && 'hidden' : ''} ${Fields?.description?.length > 250 ? 'w-[100%]' : ' w-[48%]'} flex gap-[10px]`}>
                                                        <div className="w-[100%]">
                                                            <>
                                                                <CustomFileInput options={Fields?.options}
                                                                    disabled={question?.docs_answers?.length > 0}

                                                                    required={Fields?.mandatory > 0 ? true : false}
                                                                    onChange={fileHandler}
                                                                    value={formik?.values?.[Fields?.question_no]?.fileName}
                                                                    name={Fields.question_no} label={Fields.question}
                                                                />
                                                                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                                                <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                              </>
                                                        </div>
                                                        {question?.docs_answers?.length > 0 && question?.docs_answers?.some(doc => doc?.answer) &&
                                                            <div className="flex gap-[10px] mt-[8px]">
                                                                <div onClick={() => commonEditOpenModal('comment', Fields, formik?.values)} className="bg-[#004878] h-fit rounded-full p-[8px]">
                                                                    <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    : ''
                            }

                        </>
                    )}


                </div >
                {
                    question?.docs_answers.length > 0 ?
                        ''
                        :
                        <div className='flex justify-end'>
                            <ButtonComp type={'submit'} className='px-[20px] py-[6px] h-[40px] text-white bg-[#004878] rounded-full' text='Save & Next' />
                        </div>
                }
            </form >

            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['comment']} closeModal={commonEditCloseModal} >
                <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Comment' />
                <ParagraphComp className='text-lg text-black text-center' >
                    {isModalOpen?.type?.toLowerCase() === 'section' ?
                        ((question?.docs_answers?.length > 0 &&
                            Array.isArray(question?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer)) &&
                            question?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator' :
                        (question?.docs_answers?.length > 0 &&
                            question?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator.'}
                </ParagraphComp>
                <div className="flex justify-end">
                    <ButtonComp onClick={commonEditCloseModal} type='button' className=' mt-[10px] py-[5px] px-[10px] rounded-[20px] border-2 border-[#004878] text-[#004878]'>
                        Close
                    </ButtonComp>
                </div>

            </ModalComp>
            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['edit']} closeModal={commonEditCloseModal} >
                {console.log("isModalOpen>>>>>", isModalOpen)}
                <Formik
                    enableReinitialize
                    initialValues={{
                        [isModalOpen?.data?.question_no || 'default_question_no']: '',
                    }}
                    validationSchema={editModalSchema}
                    onSubmit={(values) => {
                        updateValues(values);
                    }}
                >


                    {({ values: modalValues, errors: modalErrors, handleChange, setFieldValue: setModalFieldValue }) => (

                        <Form action="">
                            {console.log("modalErrors>>>>", modalErrors)}
                            <div className='h-auto'>
                                <div className='flex justify-end'>
                                    <div className='cursor-pointer' onClick={commonEditCloseModal}>
                                        <CloseIcon />
                                    </div>
                                </div>
                                <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Edit' />
                                <ParagraphComp className='text-lg text-black text-start' text='Question' />
                                <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' text={isModalOpen?.data?.question} />
                                {isModalOpen?.type?.toLowerCase() === 'section' ?
                                    formik?.values?.[isModalOpen?.template][isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                                    (question?.docs_answers?.length > 0 &&
                                        question?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.find(ele => ele.question_no === isModalOpen?.data.question_no)) || '' :
                                    formik?.values?.normalFields?.[isModalOpen?.data?.question_no] ||
                                        (question?.docs_answers?.length > 0 &&
                                            question?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer)
                                        ?
                                        <ParagraphComp className='text-lg mt-[10px] text-black text-start' text='Current Answer' />
                                        : ''
                                }
                                <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' >
                                    {isModalOpen?.type?.toLowerCase() === 'section' ?
                                        formik?.values?.[isModalOpen?.template][isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                                        (question?.docs_answers?.length > 0 &&
                                            question?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.find(ele => ele.question_no === isModalOpen?.data.question_no)) || '' :
                                        formik?.values?.normalFields?.[isModalOpen?.data?.question_no] ||
                                        (question?.docs_answers?.length > 0 &&
                                            question?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || ''}
                                </ParagraphComp>
                                {isModalOpen?.data?.type.toLowerCase() === 'text' || isModalOpen?.data?.type.toLowerCase() === 'number' || isModalOpen?.data?.type.toLowerCase() === 'date' || isModalOpen?.data?.type.toLowerCase() === 'password' ?
                                    < div className='mt-[20px]'>
                                        <CustomInput required={true}
                                            type={isModalOpen?.data?.type?.toLowerCase()}
                                            name={isModalOpen?.data?.question_no}
                                            value={modalValues?.[isModalOpen?.data?.question_no]}
                                            onChange={handleChange} label='New Answer' />
                                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                    </div>
                                    :
                                    isModalOpen?.data?.type.toLowerCase() === 'dropdown' ?
                                        < div className='mt-[20px]'>
                                            <CustomSelection
                                                imgKey='flag'
                                                exDataKey={isModalOpen?.data?.question === 'Country Code' ? 'label' : undefined}
                                                mappingKey={isModalOpen?.data?.question === 'Country Code' ? 'phone' : undefined}
                                                options={isModalOpen?.data?.options}
                                                required={true}
                                                value={modalValues?.[isModalOpen?.data.question_no]}
                                                onChange={handleChange}
                                                name={isModalOpen?.data.question_no}
                                                label='New Answer'
                                            />
                                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                        </div>
                                        : isModalOpen?.data?.type.toLowerCase() === 'multiselect dropdown' ?
                                            < div className='mt-[20px]'>
                                                <MultipleSelect
                                                    required={true}
                                                    options={isModalOpen?.data?.options
                                                    }
                                                    maxSelect={isModalOpen?.data.validation === 'Select Upto 3' && 3}
                                                    mappingKey={isModalOpen?.data?.question_no !== "DRQ-00077" ? "option" : 'option'} // Pass mapping key if needed
                                                    onValueChange={(values) => modalMultiSelectedValues(formik?.values, setModalFieldValue)}
                                                    selectedValues={formik?.values?.[isModalOpen?.data?.question_no] || []}
                                                    name={isModalOpen?.data?.question_no}
                                                    label='New Answer'
                                                />
                                                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />

                                            </div>
                                            :
                                            isModalOpen?.data?.type.toLowerCase() === 'attach' ?
                                                <div className='mt-[20px]'>
                                                    <CustomFileInput
                                                        required={true}
                                                        onChange={(e) => attachFile(e, setModalFieldValue)}
                                                        value={modalValues?.[isModalOpen?.data?.question_no].file_name}
                                                        name={isModalOpen?.data?.question_no}
                                                        label="New Answer"
                                                    />
                                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                                </div>
                                                : ''

                                }

                                <div className="flex justify-center mt-[15px]">
                                    <ButtonComp
                                        disabled={editLoading ? true : false}
                                        className="w-[150px] rounded-full bg-[#004878] p-[6px] text-white border-none"
                                        type="Submit"
                                        text={editLoading ? "Saving..." : "Save"}
                                    />
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalComp>
        </>
    );
};

export default LegalRegistration;
